"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PendingAssociationQuote_1 = __importDefault(require("@becrop/components/Modules/Common/Models/PendingAssociationQuote"));
const Status_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Status"));
const axios_1 = __importDefault(require("axios"));
class Proposal {
    constructor(obj) {
        this.id = obj.id || -1;
        this.code_name = obj.code_name || '';
        this.name = obj.name || '';
        this.accepted_at = obj.accepted_at || '';
        this.contact = obj.contact || {
            'name': '',
            'email': ''
        };
        this.status = obj.status || new Status_1.default({});
        this.status_number = obj.status_number || -1;
        this.deliverables = obj.deliverables || [];
        this.deliverables_details = obj.deliverables_details || [];
        this.pending_association_quotes = obj.pending_association_quotes || [];
        this.pending_association_quotes = this.pending_association_quotes.map((q) => new PendingAssociationQuote_1.default(q));
    }
    async toggleVisibilityProject(id, newVisibility) {
        let response = {
            status: true,
            message: 'Changes successfully saved',
            errors: []
        };
        try {
            const resp = await axios_1.default.get('/rate/' + id + '/setIsPublished');
            this.deliverables.forEach((d) => {
                if (d.areas.some((a) => a.meta.id === id)) {
                    d.visibility = newVisibility;
                }
            });
            return response;
        }
        catch (e) {
            response.status = false;
            response.message = e.response.data.message;
            return response;
        }
    }
}
exports.default = Proposal;
